import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import PostApprovalPlaidProcessingView from './PostApprovalPlaidProcessingView';
import usePostApprovalPlaidProcessing from '../../../hooks/usePostApprovalPlaidProcessing';

const PostApprovalPlaidProcessing = ({
  routeOnTerminal,
  onTerminal,
  headline,
  subcopy,
}) => {
  const history = useHistory();
  const plaid = usePostApprovalPlaidProcessing({ routeOnTerminal, onTerminal });
  const retryStatus = () => {
    const request = plaid.retryStatus();
    if (request) request.catch(() => undefined);
  };
  const retryEntities = () => {
    const request = plaid.retryEntities();
    if (request) request.catch(() => undefined);
  };
  const retryRoute = () => plaid.retryRoute();

  useEffect(() => {
    if (plaid.phase === 'terminal' && plaid.routeNow) {
      plaid.continueToNextRoute(history);
    }
  }, [history, plaid]);

  return (
    <PostApprovalPlaidProcessingView
      busy={plaid.loading || plaid.routeLoading}
      headline={headline}
      onReauthenticate={() => plaid.reauthenticate(history)}
      onRetryEntities={retryEntities}
      onRetryRoute={retryRoute}
      onRetryStatus={retryStatus}
      presentation={plaid.presentation}
      recoveryAction={
        plaid.routeError
          ? 'route'
          : plaid.phase === 'entity_refresh_error'
          ? 'entities'
          : 'status'
      }
      subcopy={subcopy}
    />
  );
};

export default PostApprovalPlaidProcessing;
